module.exports = __webpack_public_path__ + "img/quard12.acb7dbff.png";